module.exports = __webpack_public_path__ + "static/media/dice-d20.273d881f.svg";